import React from 'react';
import {
  PhoneOutlined,
  CheckCircleOutlined,
  AccessTimeOutlined,
  CancelOutlined,
  SystemUpdateAltOutlined,
  SwapHorizOutlined,
  TrendingUpOutlined,
  ErrorOutlineOutlined,
  StarOutlineOutlined,
  LocalOfferOutlined,
  MoodOutlined,
} from '@mui/icons-material';
import { AnalyticsMetric, MetricCardType } from '../const';
import type { AllMetricType } from '../types';

interface IconConfig {
  fontSize: number;
  className: string;
}

const defaultIconConfig: IconConfig = {
  fontSize: 24,
  className: '',
};

const smallIconConfig: IconConfig = {
  fontSize: 20,
  className: '',
};

export const getIconForType = (
  type: AllMetricType,
  size: 'default' | 'small' = 'default'
): React.ReactElement => {
  const config = size === 'small' ? smallIconConfig : defaultIconConfig;
  const iconProps = {
    style: { fontSize: config.fontSize },
    className: config.className,
    sx: { color: '#505962' },
  };

  switch (type) {
    case MetricCardType.DURATION_SECONDS:
      return <PhoneOutlined {...iconProps} />;
    case MetricCardType.AVERAGE_RESPONSE_TIME_SECONDS:
      return <AccessTimeOutlined {...iconProps} />;
    case MetricCardType.CSAT_STARS:
      return <StarOutlineOutlined {...iconProps} />;
    case AnalyticsMetric.SUCCESS_RATE:
      return <CheckCircleOutlined {...iconProps} />;
    case AnalyticsMetric.ERROR_RATE:
      return <ErrorOutlineOutlined {...iconProps} />;
    case AnalyticsMetric.USER_ABANDONED:
      return <CancelOutlined {...iconProps} />;

    case AnalyticsMetric.SYSTEM_AVAILABILITY:
      return <SystemUpdateAltOutlined {...iconProps} />;
    case AnalyticsMetric.TOPIC_TAGS:
      return <LocalOfferOutlined {...iconProps} />;
    case AnalyticsMetric.MOOD_TAGS:
      return <MoodOutlined {...iconProps} />;

    case AnalyticsMetric.HUMAN_ESCALATION:
      return <SwapHorizOutlined {...iconProps} />;
    case AnalyticsMetric.MAX_CONCURRENCY:
      return <TrendingUpOutlined {...iconProps} />;

    default:
      return <AccessTimeOutlined {...iconProps} />;
  }
};
